/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 1ae6e2d8 (Tue May  5 20:16:57 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  AcademicYearPrograms,
  AcademicYearProgramsFromJSON,
  Communities,
  CommunitiesFromJSON,
  EditBusinessEmailRequestBody,
  EditBusinessEmailRequestBodyToJSON,
  FetchUserNdaStatusResponseBody,
  FetchUserNdaStatusResponseBodyFromJSON,
  UserCommunity,
  UserCommunityFromJSON,
  UserProfile,
  UserProfileEditBody,
  UserProfileEditBodyToJSON,
  UserProfileFromJSON,
  UserTeam,
  UserTeamFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface EditBusinessEmailRequest
  extends runtime.BaseRequestParameters {
  userId: string
  body?: EditBusinessEmailRequestBody
}

export interface EditUserProfileRequest extends runtime.BaseRequestParameters {
  body: UserProfileEditBody
}

export interface FetchCommunitiesForUserRequest
  extends runtime.BaseRequestParameters {
  userId: string
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  academicYear?: number
  search?: string
}

export interface FetchProgramsForUserRequest
  extends runtime.BaseRequestParameters {
  userId: string
}

export interface FetchTeamForUserRequest extends runtime.BaseRequestParameters {
  userId: string
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  actorKey?: number
  teamStatus?: FetchTeamForUserTeamStatusEnum
}

export interface FetchUserCommunitiesRequest
  extends runtime.BaseRequestParameters {
  userId: string
  validNow?: boolean
}

export interface FetchUserNdaStatusRequest
  extends runtime.BaseRequestParameters {
  assetKey: number
}

export interface FetchUserProfileRequest extends runtime.BaseRequestParameters {
  userId: string
}

/**
 * UsersApi - interface
 *
 * @export
 * @interface UsersApiInterface
 */
export interface UsersApiInterface {
  /**
   *
   * @summary This endpoint allows the user to update their business email.
   * @param {string} userId If &#x60;me&#x60;, then the current &#x60;userId&#x60; from the session will be used.
   * @param {EditBusinessEmailRequestBody} [editBusinessEmailRequestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApiInterface
   */
  editBusinessEmailRaw(
    requestParameters: EditBusinessEmailRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * This endpoint allows the user to update their business email.
   */
  editBusinessEmail(requestParameters: EditBusinessEmailRequest): Promise<void>

  /**
   *
   * @summary Edits the user’s profile information.
   * @param {UserProfileEditBody} userProfileEditBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApiInterface
   */
  editUserProfileRaw(
    requestParameters: EditUserProfileRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Edits the user’s profile information.
   */
  editUserProfile(requestParameters: EditUserProfileRequest): Promise<void>

  /**
   *    Calling this for the \'me\' will give you a list of communities the current user is currently enrolled in or managing. Providing a \'userId\' will give you a list of communities that specific user manages or is enrolled in, if the requesting user is allowed to do so.      ## FILTERING:   - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to a community\'s name and support rep name.   - academicYear: will return communities within the specific year     ## PAGINATION:   - Pagination is only utilized for managedCommunities, and has no effect on the results of memberCommunities.   - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy.   - orderBy: valid order by properties include: name. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.
   * @summary List of communities enrolled or managed by a user.
   * @param {string} userId If &#x60;me&#x60;, then the current &#x60;userId&#x60; from the session will be used.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {number} [academicYear] Supply an academic year to filter communities to a specific year.
   * @param {string} [search] Search for communities by name or Support Rep full name. Must be at least 3 characters in length.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApiInterface
   */
  fetchCommunitiesForUserRaw(
    requestParameters: FetchCommunitiesForUserRequest
  ): Promise<runtime.ApiResponse<Communities>>

  /**
   *    Calling this for the \'me\' will give you a list of communities the current user is currently enrolled in or managing. Providing a \'userId\' will give you a list of communities that specific user manages or is enrolled in, if the requesting user is allowed to do so.      ## FILTERING:   - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to a community\'s name and support rep name.   - academicYear: will return communities within the specific year     ## PAGINATION:   - Pagination is only utilized for managedCommunities, and has no effect on the results of memberCommunities.   - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy.   - orderBy: valid order by properties include: name. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.
   * List of communities enrolled or managed by a user.
   */
  fetchCommunitiesForUser(
    requestParameters: FetchCommunitiesForUserRequest
  ): Promise<Communities>

  /**
   *  Lists programs available to the user by academic year. \'me\' lists programs available for the current user, \'userId:\' provides programs available for the given user. When the specified userId is \'me\' or the same as the requester\'s userKey, programs will be returned that the requester can see.  PERMISSIONS FOR ME/CURRENT USER KEY: - No permissions: A user can always see the programs that they are \'in\'. Being in a program means that the user has an active enrollment in the program, OR is the director or tutor of the program and the director/tutor role is active. - Program/view[their team\'s] allows the requester to view programs in their downline team. - Program/view[any] allows the requester to view all programs.  If the specified userId is not \'me\' or the same as the logged in user, the requester must be able to see the requested user. The returned programs are the intersection between the programs that the requester can see, AND the programs that the requested user can see. This follows the same rules as above. A 400 status code will be returned if the requester cannot see the requested user, or if the requested user does not exist.  PERMISSIONS FOR OTHER USER KEY: - User/view[their team\'s] allows the requester returns programs of the requested user if that user is within the requester\'s team (downline or direct supervisor). - User/view[any] allows the requester to see programs of all users. - The intersection between programs the requester and the requested user can see is determined by the same Program/view permissions above for BOTH users.
   * @summary List of programs by academic year available for the specified user.
   * @param {string} userId If &#x60;me&#x60;, then the current &#x60;userId&#x60; from the session will be used.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApiInterface
   */
  fetchProgramsForUserRaw(
    requestParameters: FetchProgramsForUserRequest
  ): Promise<runtime.ApiResponse<Array<AcademicYearPrograms>>>

  /**
   *  Lists programs available to the user by academic year. \'me\' lists programs available for the current user, \'userId:\' provides programs available for the given user. When the specified userId is \'me\' or the same as the requester\'s userKey, programs will be returned that the requester can see.  PERMISSIONS FOR ME/CURRENT USER KEY: - No permissions: A user can always see the programs that they are \'in\'. Being in a program means that the user has an active enrollment in the program, OR is the director or tutor of the program and the director/tutor role is active. - Program/view[their team\'s] allows the requester to view programs in their downline team. - Program/view[any] allows the requester to view all programs.  If the specified userId is not \'me\' or the same as the logged in user, the requester must be able to see the requested user. The returned programs are the intersection between the programs that the requester can see, AND the programs that the requested user can see. This follows the same rules as above. A 400 status code will be returned if the requester cannot see the requested user, or if the requested user does not exist.  PERMISSIONS FOR OTHER USER KEY: - User/view[their team\'s] allows the requester returns programs of the requested user if that user is within the requester\'s team (downline or direct supervisor). - User/view[any] allows the requester to see programs of all users. - The intersection between programs the requester and the requested user can see is determined by the same Program/view permissions above for BOTH users.
   * List of programs by academic year available for the specified user.
   */
  fetchProgramsForUser(
    requestParameters: FetchProgramsForUserRequest
  ): Promise<Array<AcademicYearPrograms>>

  /**
   * It will fetch the direct team members (actors) for the logged in user if userId = me, or the direct team for the provided userId, including those who either me or userID is supported by.   If actorKey is passed in the query string, then it will only pull the teams for that specific actor.
   * @summary Fetch user\'s supported actors (team members) and actors they\'re supported by. All of them with their associated users and roles
   * @param {string} userId If &#x60;me&#x60;, then the current &#x60;userId&#x60; from the session will be used.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {number} [actorKey] The unique identifier for the actor record that we should pull the teams for.
   * @param {'Active' | 'Inactive' | 'Both'} [teamStatus] The status of the actors on the team to pull back. Active, inactive or both
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApiInterface
   */
  fetchTeamForUserRaw(
    requestParameters: FetchTeamForUserRequest
  ): Promise<runtime.ApiResponse<UserTeam>>

  /**
   * It will fetch the direct team members (actors) for the logged in user if userId = me, or the direct team for the provided userId, including those who either me or userID is supported by.   If actorKey is passed in the query string, then it will only pull the teams for that specific actor.
   * Fetch user\'s supported actors (team members) and actors they\'re supported by. All of them with their associated users and roles
   */
  fetchTeamForUser(
    requestParameters: FetchTeamForUserRequest
  ): Promise<UserTeam>

  /**
   *
   * @summary Returns the user’s communities and their roles therein, if any.
   * @param {string} userId If &#x60;me&#x60;, then the current &#x60;userId&#x60; from the session will be used.
   * @param {boolean} [validNow] Indicates whether the actor roles to return are validNow or not.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApiInterface
   */
  fetchUserCommunitiesRaw(
    requestParameters: FetchUserCommunitiesRequest
  ): Promise<runtime.ApiResponse<Array<UserCommunity>>>

  /**
   * Returns the user’s communities and their roles therein, if any.
   */
  fetchUserCommunities(
    requestParameters: FetchUserCommunitiesRequest
  ): Promise<Array<UserCommunity>>

  /**
   * Returns the NDA signing status for the authenticated user for the specified asset.
   * @summary Check if the current user has signed the NDA
   * @param {number} assetKey Unique indentifier for the widen asset
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApiInterface
   */
  fetchUserNdaStatusRaw(
    requestParameters: FetchUserNdaStatusRequest
  ): Promise<runtime.ApiResponse<FetchUserNdaStatusResponseBody>>

  /**
   * Returns the NDA signing status for the authenticated user for the specified asset.
   * Check if the current user has signed the NDA
   */
  fetchUserNdaStatus(
    requestParameters: FetchUserNdaStatusRequest
  ): Promise<FetchUserNdaStatusResponseBody>

  /**
   *
   * @summary Returns the user’s profile.
   * @param {string} userId If &#x60;me&#x60;, then the current &#x60;userId&#x60; from the session will be used.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApiInterface
   */
  fetchUserProfileRaw(
    requestParameters: FetchUserProfileRequest
  ): Promise<runtime.ApiResponse<UserProfile>>

  /**
   * Returns the user’s profile.
   */
  fetchUserProfile(
    requestParameters: FetchUserProfileRequest
  ): Promise<UserProfile>
}

/**
 *
 */
export class UsersApi extends runtime.BaseAPI implements UsersApiInterface {
  /**
   * This endpoint allows the user to update their business email.
   */
  async editBusinessEmailRaw(
    requestParameters: EditBusinessEmailRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.userId === null ||
      requestParameters.userId === undefined
    ) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter requestParameters.userId was null or undefined when calling editBusinessEmail.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/u/{userId}/editBusinessEmail`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(requestParameters.userId))
      ),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: EditBusinessEmailRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * This endpoint allows the user to update their business email.
   */
  async editBusinessEmail(
    requestParameters: EditBusinessEmailRequest
  ): Promise<void> {
    await this.editBusinessEmailRaw(requestParameters)
  }

  /**
   * Edits the user’s profile information.
   */
  async editUserProfileRaw(
    requestParameters: EditUserProfileRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling editUserProfile.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/u/`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: UserProfileEditBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Edits the user’s profile information.
   */
  async editUserProfile(
    requestParameters: EditUserProfileRequest
  ): Promise<void> {
    await this.editUserProfileRaw(requestParameters)
  }

  /**
   *    Calling this for the \'me\' will give you a list of communities the current user is currently enrolled in or managing. Providing a \'userId\' will give you a list of communities that specific user manages or is enrolled in, if the requesting user is allowed to do so.      ## FILTERING:   - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to a community\'s name and support rep name.   - academicYear: will return communities within the specific year     ## PAGINATION:   - Pagination is only utilized for managedCommunities, and has no effect on the results of memberCommunities.   - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy.   - orderBy: valid order by properties include: name. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.
   * List of communities enrolled or managed by a user.
   */
  async fetchCommunitiesForUserRaw(
    requestParameters: FetchCommunitiesForUserRequest
  ): Promise<runtime.ApiResponse<Communities>> {
    if (
      requestParameters.userId === null ||
      requestParameters.userId === undefined
    ) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter requestParameters.userId was null or undefined when calling fetchCommunitiesForUser.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.academicYear !== undefined) {
      queryParameters['academicYear'] = requestParameters.academicYear
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/u/{userId}/communities`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(requestParameters.userId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CommunitiesFromJSON(jsonValue)
    )
  }

  /**
   *    Calling this for the \'me\' will give you a list of communities the current user is currently enrolled in or managing. Providing a \'userId\' will give you a list of communities that specific user manages or is enrolled in, if the requesting user is allowed to do so.      ## FILTERING:   - search: search text must be at least 3 characters in length. Including this query parameter will match your search text to a community\'s name and support rep name.   - academicYear: will return communities within the specific year     ## PAGINATION:   - Pagination is only utilized for managedCommunities, and has no effect on the results of memberCommunities.   - If pagination query parameters are included, the request will be paginated and ordered by the specified page, pageSize, and orderBy.   - orderBy: valid order by properties include: name. Supplying anything else will result in an error. - The requested pagination will be returned in the response, including the total count of all data, which will allow the requester to calculate the total amount of pages available with the current pageSize.
   * List of communities enrolled or managed by a user.
   */
  async fetchCommunitiesForUser(
    requestParameters: FetchCommunitiesForUserRequest
  ): Promise<Communities> {
    const response = await this.fetchCommunitiesForUserRaw(requestParameters)
    return await response.value()
  }

  /**
   *  Lists programs available to the user by academic year. \'me\' lists programs available for the current user, \'userId:\' provides programs available for the given user. When the specified userId is \'me\' or the same as the requester\'s userKey, programs will be returned that the requester can see.  PERMISSIONS FOR ME/CURRENT USER KEY: - No permissions: A user can always see the programs that they are \'in\'. Being in a program means that the user has an active enrollment in the program, OR is the director or tutor of the program and the director/tutor role is active. - Program/view[their team\'s] allows the requester to view programs in their downline team. - Program/view[any] allows the requester to view all programs.  If the specified userId is not \'me\' or the same as the logged in user, the requester must be able to see the requested user. The returned programs are the intersection between the programs that the requester can see, AND the programs that the requested user can see. This follows the same rules as above. A 400 status code will be returned if the requester cannot see the requested user, or if the requested user does not exist.  PERMISSIONS FOR OTHER USER KEY: - User/view[their team\'s] allows the requester returns programs of the requested user if that user is within the requester\'s team (downline or direct supervisor). - User/view[any] allows the requester to see programs of all users. - The intersection between programs the requester and the requested user can see is determined by the same Program/view permissions above for BOTH users.
   * List of programs by academic year available for the specified user.
   */
  async fetchProgramsForUserRaw(
    requestParameters: FetchProgramsForUserRequest
  ): Promise<runtime.ApiResponse<Array<AcademicYearPrograms>>> {
    if (
      requestParameters.userId === null ||
      requestParameters.userId === undefined
    ) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter requestParameters.userId was null or undefined when calling fetchProgramsForUser.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/u/{userId}/programs`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(requestParameters.userId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AcademicYearProgramsFromJSON)
    )
  }

  /**
   *  Lists programs available to the user by academic year. \'me\' lists programs available for the current user, \'userId:\' provides programs available for the given user. When the specified userId is \'me\' or the same as the requester\'s userKey, programs will be returned that the requester can see.  PERMISSIONS FOR ME/CURRENT USER KEY: - No permissions: A user can always see the programs that they are \'in\'. Being in a program means that the user has an active enrollment in the program, OR is the director or tutor of the program and the director/tutor role is active. - Program/view[their team\'s] allows the requester to view programs in their downline team. - Program/view[any] allows the requester to view all programs.  If the specified userId is not \'me\' or the same as the logged in user, the requester must be able to see the requested user. The returned programs are the intersection between the programs that the requester can see, AND the programs that the requested user can see. This follows the same rules as above. A 400 status code will be returned if the requester cannot see the requested user, or if the requested user does not exist.  PERMISSIONS FOR OTHER USER KEY: - User/view[their team\'s] allows the requester returns programs of the requested user if that user is within the requester\'s team (downline or direct supervisor). - User/view[any] allows the requester to see programs of all users. - The intersection between programs the requester and the requested user can see is determined by the same Program/view permissions above for BOTH users.
   * List of programs by academic year available for the specified user.
   */
  async fetchProgramsForUser(
    requestParameters: FetchProgramsForUserRequest
  ): Promise<Array<AcademicYearPrograms>> {
    const response = await this.fetchProgramsForUserRaw(requestParameters)
    return await response.value()
  }

  /**
   * It will fetch the direct team members (actors) for the logged in user if userId = me, or the direct team for the provided userId, including those who either me or userID is supported by.   If actorKey is passed in the query string, then it will only pull the teams for that specific actor.
   * Fetch user\'s supported actors (team members) and actors they\'re supported by. All of them with their associated users and roles
   */
  async fetchTeamForUserRaw(
    requestParameters: FetchTeamForUserRequest
  ): Promise<runtime.ApiResponse<UserTeam>> {
    if (
      requestParameters.userId === null ||
      requestParameters.userId === undefined
    ) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter requestParameters.userId was null or undefined when calling fetchTeamForUser.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    if (requestParameters.teamStatus !== undefined) {
      queryParameters['teamStatus'] = requestParameters.teamStatus
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/u/{userId}/team`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(requestParameters.userId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UserTeamFromJSON(jsonValue)
    )
  }

  /**
   * It will fetch the direct team members (actors) for the logged in user if userId = me, or the direct team for the provided userId, including those who either me or userID is supported by.   If actorKey is passed in the query string, then it will only pull the teams for that specific actor.
   * Fetch user\'s supported actors (team members) and actors they\'re supported by. All of them with their associated users and roles
   */
  async fetchTeamForUser(
    requestParameters: FetchTeamForUserRequest
  ): Promise<UserTeam> {
    const response = await this.fetchTeamForUserRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns the user’s communities and their roles therein, if any.
   */
  async fetchUserCommunitiesRaw(
    requestParameters: FetchUserCommunitiesRequest
  ): Promise<runtime.ApiResponse<Array<UserCommunity>>> {
    if (
      requestParameters.userId === null ||
      requestParameters.userId === undefined
    ) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter requestParameters.userId was null or undefined when calling fetchUserCommunities.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.validNow !== undefined) {
      queryParameters['validNow'] = requestParameters.validNow
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/u/{userId}/roles`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(requestParameters.userId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(UserCommunityFromJSON)
    )
  }

  /**
   * Returns the user’s communities and their roles therein, if any.
   */
  async fetchUserCommunities(
    requestParameters: FetchUserCommunitiesRequest
  ): Promise<Array<UserCommunity>> {
    const response = await this.fetchUserCommunitiesRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns the NDA signing status for the authenticated user for the specified asset.
   * Check if the current user has signed the NDA
   */
  async fetchUserNdaStatusRaw(
    requestParameters: FetchUserNdaStatusRequest
  ): Promise<runtime.ApiResponse<FetchUserNdaStatusResponseBody>> {
    if (
      requestParameters.assetKey === null ||
      requestParameters.assetKey === undefined
    ) {
      throw new runtime.RequiredError(
        'assetKey',
        'Required parameter requestParameters.assetKey was null or undefined when calling fetchUserNdaStatus.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/u/ndaStatus/{assetKey}`.replace(
        `{${'assetKey'}}`,
        encodeURIComponent(String(requestParameters.assetKey))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchUserNdaStatusResponseBodyFromJSON(jsonValue)
    )
  }

  /**
   * Returns the NDA signing status for the authenticated user for the specified asset.
   * Check if the current user has signed the NDA
   */
  async fetchUserNdaStatus(
    requestParameters: FetchUserNdaStatusRequest
  ): Promise<FetchUserNdaStatusResponseBody> {
    const response = await this.fetchUserNdaStatusRaw(requestParameters)
    return await response.value()
  }

  /**
   * Returns the user’s profile.
   */
  async fetchUserProfileRaw(
    requestParameters: FetchUserProfileRequest
  ): Promise<runtime.ApiResponse<UserProfile>> {
    if (
      requestParameters.userId === null ||
      requestParameters.userId === undefined
    ) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter requestParameters.userId was null or undefined when calling fetchUserProfile.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/u/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(requestParameters.userId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UserProfileFromJSON(jsonValue)
    )
  }

  /**
   * Returns the user’s profile.
   */
  async fetchUserProfile(
    requestParameters: FetchUserProfileRequest
  ): Promise<UserProfile> {
    const response = await this.fetchUserProfileRaw(requestParameters)
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum FetchTeamForUserTeamStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
  Both = 'Both',
}
